export enum DeviceOrientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape'
}
